import { useState } from "react";
import { ChatMessage, ConversationState } from "@/components/agent/chat/types";
import { useDataFetching } from "./useDataFetching";
import { Tables } from "@/types/database.types";

type Agent = Tables<"agents">;

export const useConversationState = (
  agent: Agent,
  chatMessages: ChatMessage[],
  setChatMessages: (messages: ChatMessage[]) => void
) => {
  const [conversationState, setConversationState] =
    useState<ConversationState>("open");
  const { extractFormFields } = useDataFetching();

  const handleConversationCompletion = async (conversationId: string) => {
    if (conversationState === "completed") return;

    try {
      setConversationState("completed");
      console.log("Conversation has been marked as completed by the AI");

      // Call the extract-form-fields edge function to extract form values
      await extractFormFields(conversationId, agent.id);
    } catch (error) {
      console.error("Error handling conversation completion:", error);
    }
  };

  return {
    conversationState,
    setConversationState,
    handleConversationCompletion,
  };
};
